const HUNDRED_THOUSAND_EUROS_IN_CENTS = 100_000_00;
const TEN_MILLION_EUROS_IN_CENTS = 10_000_000_00;

export function balanceTextSizeClass(balanceCents: number): string {
    const magnitude = Math.abs(balanceCents);
    if (magnitude < HUNDRED_THOUSAND_EUROS_IN_CENTS) {
        return 'text-[28px]';
    }
    if (magnitude < TEN_MILLION_EUROS_IN_CENTS) {
        return 'text-[24px]';
    }
    return 'text-[20px]';
}
